import { render, staticRenderFns } from "./BindTeacherMobile.vue?vue&type=template&id=f192094e&scoped=true"
import script from "./BindTeacherMobile.vue?vue&type=script&lang=js"
export * from "./BindTeacherMobile.vue?vue&type=script&lang=js"
import style0 from "./BindTeacherMobile.vue?vue&type=style&index=0&id=f192094e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f192094e",
  null
  
)

export default component.exports